import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { getGlobalsReq, imgBase, updGlobalsReq } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import TextInput from '../components/textInput';
import AreaInput from '../components/areaInput';
import { defImg, minToMill } from '../config/globals';

class Globals extends React.Component {
	constructor(props) {
		super(props);

		this.imgInputRef = React.createRef();

		this.state = {
			cutoff: '',
			// min_order: '',
			user_title: '',
			user_subtitle: '',
			festivity_title: '',
			festivity_subtitle: '',
			festivity_image: '',
			img: null,
			auto_dec: '',
			errors: { cutoff: ''/* , min_order: '' */ },
			loading: false,
			fetchLoading: true
		};
	}

	componentDidMount() {
		this.getGlobals();
	}

	getGlobals = () => {
		this.setState({fetchLoading: true});
		getGlobalsReq()
		.then( (res) => {
			this.setState({...res.data, festivity_image: res.data.festivity_image === 'null' ? '' : res.data.festivity_image, img: null/* , auto_dec: res.data.auto_dec/minToMill */});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not fetch globals");
		}).finally( () => {
			this.setState({fetchLoading: false});
		});
	}
	
	handleChange = ({ target: { name, value } }) => {
		this.setState({[name]: value});
	}

	validate = () => {
		const { cutoff/* , min_order */ } = this.state;
		let errors = { cutoff: ''/* , min_order: '' */ }, isValid = true;

		if(!cutoff && cutoff !== 0) {
			errors.cutoff = "Enter cutoff to continue";
			isValid = false;
		}
		// if(!min_order && min_order !== 0) {
		// 	errors.min_order = "Enter minimum order amount to continue";
		// 	isValid = false;
		// }

		this.setState({errors});
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { cutoff, user_subtitle, user_title, auto_dec, festivity_title, festivity_subtitle, festivity_image, img } = this.state;
		if(this.validate()) {
			this.setState({loading: true});
			const formData = new FormData();
			formData.append('cutoff', cutoff);
			formData.append('user_subtitle', user_subtitle);
			formData.append('user_title', user_title);
			formData.append('auto_dec', auto_dec);
			formData.append('festivity_title', festivity_title);
			formData.append('festivity_subtitle', festivity_subtitle);
			formData.append('img', img);
			formData.append('festivity_image', img ? img.name || `${festivity_title}.${img.type.split("/")[1]}` : festivity_image);
			updGlobalsReq(formData)
			.then( (res) => {
				this.setState({loading: false});
				alertSuccess("Globals updated");
				this.getGlobals();
			}).catch( (err) => {
				this.setState({loading: false});
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
		}
	}

	onChangeFile = (e) => {
		if (e.target.files.length > 0) {
			let fileName = e.target.files[0].name;
			this.getBase64(e.target.files[0], (res) => {
				this.setState({ [e.target.name]: res, /* image: fileName, */ img: e.target.files[0] });
			});
		}
	}

	getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

	rmImage = () => {
		this.setState({festivity_image: '', img: null});
	}

	render() {
		const { cutoff, /* min_order, */ user_subtitle, user_title, festivity_title, festivity_subtitle, festivity_image, img, auto_dec, deleteLoading, errors, loading, fetchLoading } = this.state;
		const { handleChange, handleSubmit, onChangeFile, imgInputRef, rmImage } = this;
		return (
			<Row style={{marginLeft: 0, marginRight: 0}}>
				{fetchLoading && <Loader />}
				<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
					<Card style={{marginTop: '20%'}}>
						<Card.Header>
							<Card.Title style={{textAlign: 'center'}}>Update Global Values</Card.Title>
						</Card.Header>
						<Card.Body>
							<Form onSubmit={handleSubmit}>
								<Form.Group style={{position: 'relative'}}>
									<Form.Control name="festivity_image" onChange={onChangeFile} type="file" style={{display: 'none'}} ref={imgInputRef} />
									{festivity_image ?
										img ?
											<>
											<Image fluid  style={{marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer'}} onClick={() => {imgInputRef.current.click()}} src={festivity_image} />
											<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', left: '25%', bottom: 0}} onClick={() => {this.capturePicture()}}>
												<FontAwesomeIcon icon={faTrashAlt} />
											</button>
											<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', right: '25%', bottom: 0}} onClick={rmImage}>
												<FontAwesomeIcon icon={faPlus} />
											</button>
											</>
										:
											<>
											<Image fluid  style={{marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer'}} onClick={() => {imgInputRef.current.click()}} src={`${imgBase}${festivity_image}`} />
											<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', left: '25%', bottom: 0}} onClick={rmImage}>
												<FontAwesomeIcon icon={faTrashAlt} />
											</button>
											<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', right: '25%', bottom: 0}} onClick={() => {imgInputRef.current.click()}}>
												<FontAwesomeIcon icon={faPlus} />
											</button>
											</>
									:
										<>
										<Image fluid style={{marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer'}} src={defImg} />
										<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', right: '25%', bottom: 0}} onClick={() => {imgInputRef.current.click()}}>
											<FontAwesomeIcon icon={faPlus} />
										</button>
										</>
									}
								</Form.Group>

								<Form.Group>
									<TextInput onChange={handleChange} value={cutoff} error={errors.cutoff} name="cutoff" label="Cutoff" />
								</Form.Group>

								<Form.Group>
									<TextInput onChange={handleChange} value={auto_dec} name="auto_dec" label="Automatic Decline Time Limit(Minutes)" />
								</Form.Group>
								
								<Form.Group>
									<AreaInput onChange={handleChange} value={user_title} name="user_title" label="User App Title" />
								</Form.Group>
								<Form.Group>
									<AreaInput onChange={handleChange} value={user_subtitle} name="user_subtitle" label="User App Subtitle" />
								</Form.Group>
								<Form.Group>
									<AreaInput onChange={handleChange} value={festivity_title} name="festivity_title" label="Festivity Title" />
								</Form.Group>
								<Form.Group>
									<AreaInput onChange={handleChange} value={festivity_subtitle} name="festivity_subtitle" label="Festivity Subtitle" />
								</Form.Group>

								<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
									{loading ?
										<FontAwesomeIcon icon={faSpinner} spin />
									:
										'Save'
									}
								</Button>
							</Form>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		);
	}
}

export default Globals;